import { sortBy } from 'es-toolkit';
import { NominationRef } from '../../models';
import { getRoleRank } from './get-role-rank';

type AvailableKey = 'SCORE' | 'ROLE'

export const sortAwardNominationRefs = (nominationRefs: NominationRef[], key: AvailableKey, isDescending: boolean): NominationRef[] => {
  let sorted: NominationRef[];
  switch (key) {
    case 'SCORE':
      return sortBy(nominationRefs, [
        (ref) => getRoleRank(ref.role),
        (ref) => isDescending ? -(ref.score ?? 0) : (ref.score ?? 0),
      ]);
    case 'ROLE':
      sorted = sortBy(nominationRefs, [(ref) => getRoleRank(ref.role)]);
      break;
    default:
      return [...nominationRefs];
  }
  return isDescending ? sorted.reverse() : sorted;
}